import { render, staticRenderFns } from "./AddBankBranch.vue?vue&type=template&id=bb5c0eea&scoped=true&"
import script from "./AddBankBranch.vue?vue&type=script&lang=js&"
export * from "./AddBankBranch.vue?vue&type=script&lang=js&"
import style0 from "./AddBankBranch.vue?vue&type=style&index=0&id=bb5c0eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5c0eea",
  null
  
)

export default component.exports